const {formatNumber} = require('./number_utils')

function formatDollars(amt, {scale=null, precision=0, sep=',', ifNull='$ -'}={}) {
	if(amt == null || amt === '') return ifNull

	const num = Number(amt)
	if(!Number.isFinite(num)) return ifNull

	const isNegative = num < 0
	const abs = Math.abs(num)

	if(isNegative) {
		return `($${formatNumber(abs, {scale, precision, sep})})`
	} else {
		return `$${formatNumber(abs, {scale, precision, sep})}`
	}
}

export {formatDollars}
